import styled, { css } from 'styled-components';

export const PricingLine = styled.div`
display: flex;
margin: 15px 0;

${({ bold }) => bold && css`
> :first-child {
  font-weight: bold;
}
`}
`;

export const PricingLabel = styled.span`
width: ${({ isSurcharge }) => (isSurcharge ? '50%' : '100%')};
`;
